import { QuickNavigation } from "../quickNavigation/QuickNavigation";

import type { QuickNavigationItem } from "../quickNavigation/QuickNavigation";

export interface WatchViewMenuProps {
  currentItemId?: string;
  items?: QuickNavigationItem[];
  label: string;
  preLabel?: string;
}

export function WatchViewMenu({
  currentItemId,
  items,
  label,
  preLabel,
}: WatchViewMenuProps) {
  return (
    <div className="WatchViewMenu">
      <QuickNavigation
        currentItemId={currentItemId}
        preLabel={preLabel}
        label={label}
        items={items}
      />
    </div>
  );
}
